import { AreaChart, Area, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { VIZ } from "../../css/brandTokens";

// Serie mensual de 12 meses (RF-19, D-4 — no respeta el filtro de periodo). Etiqueta directa SOLO en el
// máximo y en el último punto, nunca en los 12 (plan.md §3.3-bis) — se implementa con un <text> propio
// dentro de la misma `<Area>` en vez de <LabelList>, porque LabelList no expone un filtro por punto sin
// un `content` a medida.
const TendenciaChart = ({ datos, height = 220 }) => {
  const total = (datos || []).map((d) => d.Total || 0);
  const maxTotal = total.length ? Math.max(...total) : 0;
  const ultimoIndice = datos.length - 1;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={datos} margin={{ top: 24, right: 12, left: 0, bottom: 4 }}>
        <CartesianGrid stroke={VIZ.grid} vertical={false} />
        <XAxis dataKey="Etiqueta" stroke={VIZ.axis} tickLine={false} tick={{ fill: VIZ.ink2, fontSize: 11 }} />
        <YAxis
          stroke={VIZ.axis}
          tickLine={false}
          allowDecimals={false}
          tick={{ fill: VIZ.ink2, fontSize: 11 }}
          width={28}
        />
        <Tooltip
          cursor={{ fill: "rgba(17,17,19,.05)" }}
          contentStyle={{ borderRadius: 8, borderColor: VIZ.grid, fontSize: 13 }}
        />
        <Area
          type="monotone"
          dataKey="Total"
          stroke={VIZ.serie}
          fill={VIZ.serie}
          fillOpacity={0.12}
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 4, fill: VIZ.serie }}
          label={({ x, y, value, index }) => {
            const esMaximo = maxTotal > 0 && value === maxTotal;
            const esUltimo = index === ultimoIndice;
            if (!esMaximo && !esUltimo) return null;
            return (
              <text x={x} y={y - 10} textAnchor="middle" fontSize={12} fontWeight={600} fill={VIZ.ink}>
                {value}
              </text>
            );
          }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default TendenciaChart;
